export default __webpack_public_path__ + "static/media/ESAT_LAB.9a0bf76d.png";